/* 左侧菜单 */
<template>
  <div class="zLeft-menu">
    <div class="contant" v-if="Object.keys(baseUrl).length > 0">
      <Routing
            :url="choicedUrl(meau[0].menus[0])"
            :href="meau[0].menus[0].path"
          >
        <div class="top-title" @click.native="switchRoute(meau[0].menus[0], meau[0].mainVal)">
            <span class="left-tips">
              <span v-if="mainValtab === meau[0].mainVal" ></span>
            </span>
            <span>{{meau[0].mainLabel}}</span>
        </div> 
      </Routing>
      <div v-for="(itemMeau, k) in meau" :key="k" v-if="k > 0">
        <p class="title-menus">
          <span class="left-tips">
            <span v-if="itemMeau.mainVal === mainValtab"></span>  
          </span>
          {{itemMeau.mainLabel}}
        </p>
        <div
          v-if="itemMeau.menus && itemMeau.menus.length > 0"
          v-for="(item, index) in itemMeau.menus"
          :key="index"
          class="contant-txt"
          :class="active === item.value ? 'contant-txt-active' : ''"
          v-point="{category: '个人中心-' + item.label, action: '点击事件', label: item.label, value: ''}"
        >
          <Routing
            :url="choicedUrl(item)"
            :bl="item.value === 4 || item.value === 2 ? true : false"
            :href="item.path"
          >
            <Row @click.native="switchRoute(item, itemMeau.mainVal)" type="flex" align="middle" justify="start">
              <Col span="3">
                <!-- <i v-if="active === item.value" class="iconfont icon-jiantou4"></i> -->
              </Col>
              <Col span="21" class="item-txt c-7">
                <Button type="text" class="btn-meun">{{item.label}}</Button>
              </Col>
            </Row>
          </Routing>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { meau } from "../../constants/personal-meau.js";
import Routing from "../nav/routing.vue";
export default {
  name: "ZLeftMenu",
  data() {
    return {
      meau: meau,
      active: -1,
      mainValtab: -1
    };
  },
  props: {
    baseUrl: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  components: { Routing },
  methods: {
    /* 判断baseUrl */
    choicedUrl(item) {
      switch (item.baseProject) {
        case "ssr":
          return this.baseUrl.baseNuxt;
          break;
        case "next":
          return this.baseUrl.baseNext;
          break;
        case "mall":
          return "https://b.zhulogic.com/mall/me/orders";
          break;
        default:
          return this.baseUrl.baseOld;
      }
    },
    /* 链接跳转 */
    switchRoute(item = null, mainVal = -1) {
      this.mainValtab = mainVal
      let activePath = this.$store.state.activePath || "";
      if (item) {
        this.active = item.value;
        return false;
      }
      let routeActive =
        activePath.trim().length > 0 ? activePath : this.$route.fullPath;
      let activeItem;
      meau.forEach(meauItem => {
        meauItem.menus.forEach(item => {
          if (item.path === routeActive) {
            activeItem = item;
            this.mainValtab = meauItem.mainVal;
          }
          if (
            activePath === "/my-inquiry/:id" &&
            item.path === "/my-inquiry/replace"
          ) {
            activeItem = item;
            this.mainValtab = meauItem.mainVal;
          }
        });
      });

      if (activeItem) {
        let _index = activeItem.value;
        this.active = _index;
      }
    }
  },
  watch: {
    $route() {
      this.switchRoute();
    }
  },
  created() {
    this.switchRoute();
  }
};
</script>